import { createContext, useContext, useMemo, useState } from 'react';
import Modal from '@/molecules/modals/Modal/Modal';

export const GlobalModalContext = createContext(null);

export const useGlobalModalContext = () => {
  const context = useContext(GlobalModalContext);
  if (!context) {
    throw new Error(
      'useGlobalModalContext must be used within a GlobalModalProvider'
    );
  }
  return context;
};

const defaultSettings = () => ({
  closeOnEscape: true,
  minHeight: '40vh',
  minWidth: '50vw',
  maxWidth: null,
  maxHeight: '90vh',
  padding: '48px 48px 32px',
  top: '30%',
  transform: 'translate(-50%, -30%)',
  sx: {},
});

const GlobalModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [settings, setSettings] = useState(defaultSettings());

  const openModal = ({ content, settings: newSettings = {} }) => {
    setModalContent(content);
    if (Object.keys(newSettings).length > 0) {
      setSettings({ ...defaultSettings(), ...newSettings });
    }
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setTimeout(() => {
      setModalContent(null);
      setSettings(defaultSettings());
    }, 300);
  };

  const contextValue = useMemo(
    () => ({
      openModal,
      closeModal,
    }),
    []
  );

  return (
    <GlobalModalContext.Provider value={contextValue}>
      {children}

      <Modal
        open={isOpen}
        onClose={settings.closeOnEscape ? closeModal : null}
        {...settings}
      >
        {modalContent}
      </Modal>
    </GlobalModalContext.Provider>
  );
};

export default GlobalModalProvider;
